import React, { useContext, useEffect, useState, useRef } from 'react'
import {
   Box,
   Container,
   Grid,
   Typography,
   Pagination,
   Menu,
   MenuItem,
   Button,
   Drawer,
   Checkbox,
   Slider
} from '@material-ui/core'
import { Helmet } from 'react-helmet'
import Divider from '@material-ui/core/Divider'

// components
import ProductListToolbar from '../components/fitting/FittingListToolbar'
import ProductCard from '../components/fitting/ProductCard'
import ProductListCard from '../components/fitting/ProductListCard'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'

// API
import { getPublicAPI } from '../api'
import Loader from '../components/utils/Loader'
import { useNavigate } from 'react-router-dom'

// context
import { ShoppingCartContext } from '../contexts/ShoppingCart'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'

const ProductList = () => {
   let mounted = useRef(true)
   const navigate = useNavigate()

   const { innerWidth: windowWidth, innerHeight: windowHeight } = window

   const {
      handleSizesC,
      searchC,
      setSearchC,
      selectedFittingsC,
      setSelectedFittingsC,
      setHoseSizesC,
      setDashSizesC,
      selectedHoseSizesC,
      selectedDashSizesC,
      hoseSizesC,
      price,
      dashSizesC,
      newFits,
      setNewFits,
      uploadedNewFits,
      setUploadedNewFits,
      viewC,
      setViewC,
      setSelectedHoseSizesC,
      setSelectedDashSizesC,
      setPrice,
      fittingsC,
      setFittingsC
   } = useContext(ShoppingCartContext)

   const [loading, setLoading] = useState(true)
   const [data, setData] = useState([])
   const [pageNumber, setPageNumber] = useState(1)
   const [elementsLimit, setElementsLimit] = useState(localStorage.elements_limit || 12)
   const [sortBy, setSortBy] = useState("Newest")
   

   useEffect(() => {
      if (!localStorage.auth_token) navigate('/login')

      return () => (mounted.current = false)
   }, [navigate])

    

   useEffect(() => {
      const getFittings = async () => {
         try {
            let fittingsData = await getPublicAPI('/get-fittings')
            if (fittingsData?.success) {
               mounted.current && setFittingsC(fittingsData?.data)
               mounted.current && setData(fittingsData?.data)
            }
         } catch (err) {
            console.log(err.message)
         } finally {
            mounted.current && setLoading(false)
         }
      }

      getFittings()
   }, [setFittingsC])

   

   useEffect(() => {
      try {
         
            if (searchC?.toLowerCase()) {
               let weekBefore = new Date()
               weekBefore.setDate(weekBefore.getDate() - 7)

               let hoses = []
               let dashes = []
               let searched = data.filter(
                  prod =>
                     prod.rhpn.toLowerCase().includes(searchC?.toLowerCase()) ||
                     prod.desc.toLowerCase().includes(searchC?.toLowerCase())
               )

               let fineSearched = searched
               if (newFits)
                  fineSearched = searched.filter(prod => prod.updatedAt >= weekBefore.toISOString())

               fineSearched.forEach(prod => {
                  if (prod.hSize && !hoses.includes(prod.hSize)) hoses.push(prod.hSize)
                  if (prod.dSize && !dashes.includes(prod.dSize)) dashes.push(prod.dSize)
               })

               mounted.current && setHoseSizesC(hoses)
               mounted.current && setDashSizesC(dashes)
            }
         
      } catch (err) {
         console.log('some error occured', err.message)
      }
   }, [searchC, data, setHoseSizesC, setDashSizesC, newFits, price,sortBy])

   useEffect(() => {
      try {
         let selected = []

         let weekBefore = new Date()
         weekBefore.setDate(weekBefore.getDate() - 7)
         
            if (
               price.length === 0 &&
               searchC?.toLowerCase() &&
               selectedHoseSizesC?.length > 0 &&
               selectedDashSizesC?.length > 0
            )
               selected = data.filter(
                  prod =>
                     (prod.rhpn.toLowerCase().includes(searchC?.toLowerCase()) ||
                        prod.desc.toLowerCase().includes(searchC?.toLowerCase())) &&
                     selectedHoseSizesC.includes(prod.hSize) &&
                     selectedDashSizesC.includes(prod.dSize)
               )
            else if (
               price.length === 0 &&
               searchC?.toLowerCase() &&
               selectedHoseSizesC?.length === 0 &&
               selectedDashSizesC?.length > 0
            )
               selected = data.filter(
                  prod =>
                     (prod.rhpn.toLowerCase().includes(searchC?.toLowerCase()) ||
                        prod.desc.toLowerCase().includes(searchC?.toLowerCase())) &&
                     selectedDashSizesC.includes(prod.dSize)
               )
            else if (
               price.length === 0 &&
               searchC?.toLowerCase() &&
               selectedHoseSizesC?.length > 0 &&
               selectedDashSizesC?.length === 0
            )
               selected = data.filter(
                  prod =>
                     (prod.rhpn.toLowerCase().includes(searchC?.toLowerCase()) ||
                        prod.desc.toLowerCase().includes(searchC?.toLowerCase())) &&
                     selectedHoseSizesC.includes(prod.hSize)
               )
            else if (
               price.length === 0 &&
               searchC?.toLowerCase() &&
               selectedHoseSizesC?.length === 0 &&
               selectedDashSizesC?.length === 0
            )
               selected = data.filter(
                  prod =>
                     prod.rhpn.toLowerCase().includes(searchC?.toLowerCase()) ||
                     prod.desc.toLowerCase().includes(searchC?.toLowerCase())
               )
            else if (
               price.length === 0 &&
               !searchC?.toLowerCase() &&
               selectedHoseSizesC?.length > 0 &&
               selectedDashSizesC?.length === 0
            ) {
               selected = data.filter(prod => selectedHoseSizesC.includes(prod.hSize))
            } else if (
               price.length === 0 &&
               !searchC?.toLowerCase() &&
               selectedHoseSizesC?.length === 0 &&
               selectedDashSizesC?.length > 0
            ) {
               selected = data.filter(prod => selectedDashSizesC.includes(prod.dSize))
            } else if (
               price.length === 0 &&
               !searchC?.toLowerCase() &&
               selectedHoseSizesC?.length > 0 &&
               selectedDashSizesC?.length > 0
            ) {
               selected = data.filter(
                  prod =>
                     selectedHoseSizesC.includes(prod.hSize) && selectedDashSizesC.includes(prod.dSize)
               )
            } else if (
               price.length > 0 &&
               searchC?.toLowerCase() &&
               selectedHoseSizesC?.length > 0 &&
               selectedDashSizesC?.length > 0
            ) {
               selected = data.filter(
                  prod =>
                     (prod.rhpn.toLowerCase().includes(searchC?.toLowerCase()) ||
                        prod.desc.toLowerCase().includes(searchC?.toLowerCase())) &&
                     selectedHoseSizesC.includes(prod.hSize) &&
                     selectedDashSizesC.includes(prod.dSize) &&
                     prod.lPrice > price[0] &&
                     prod.lPrice < price[1]
               )
            } else if (
               price.length > 0 &&
               searchC?.toLowerCase() &&
               selectedHoseSizesC?.length === 0 &&
               selectedDashSizesC?.length > 0
            ) {
               selected = data.filter(
                  prod =>
                     (prod.rhpn.toLowerCase().includes(searchC?.toLowerCase()) ||
                        prod.desc.toLowerCase().includes(searchC?.toLowerCase())) &&
                     selectedDashSizesC.includes(prod.dSize) &&
                     prod.lPrice > price[0] &&
                     prod.lPrice < price[1]
               )
            } else if (
               price.length > 0 &&
               searchC?.toLowerCase() &&
               selectedHoseSizesC?.length > 0 &&
               selectedDashSizesC?.length === 0
            ) {
               selected = data.filter(
                  prod =>
                     (prod.rhpn.toLowerCase().includes(searchC?.toLowerCase()) ||
                        prod.desc.toLowerCase().includes(searchC?.toLowerCase())) &&
                     selectedHoseSizesC.includes(prod.hSize) &&
                     prod.lPrice > price[0] &&
                     prod.lPrice < price[1]
               )
            } else if (
               price.length > 0 &&
               searchC?.toLowerCase() &&
               selectedHoseSizesC?.length === 0 &&
               selectedDashSizesC?.length === 0
            ) {
               selected = data.filter(
                  prod =>
                     prod.desc.toLowerCase().includes(searchC?.toLowerCase()) &&
                     prod.lPrice > price[0] &&
                     prod.lPrice < price[1]
               )
            } else if (
               price.length > 0 &&
               !searchC?.toLowerCase() &&
               selectedHoseSizesC?.length > 0 &&
               selectedDashSizesC?.length === 0
            ) {
               selected = data.filter(
                  prod =>
                     selectedHoseSizesC.includes(prod.hSize) &&
                     prod.lPrice > price[0] &&
                     prod.lPrice < price[1]
               )
            } else if (
               price.length > 0 &&
               !searchC?.toLowerCase() &&
               selectedHoseSizesC?.length === 0 &&
               selectedDashSizesC?.length > 0
            ) {
               selected = data.filter(
                  prod =>
                     selectedDashSizesC.includes(prod.dSize) &&
                     prod.lPrice > price[0] &&
                     prod.lPrice < price[1]
               )
            } else if (
               price.length > 0 &&
               !searchC?.toLowerCase() &&
               selectedHoseSizesC?.length > 0 &&
               selectedDashSizesC?.length > 0
            )
               selected = data.filter(
                  prod =>
                     selectedHoseSizesC.includes(prod.hSize) &&
                     selectedDashSizesC.includes(prod.dSize) &&
                     prod.lPrice > price[0] &&
                     prod.lPrice < price[1]
               )
            else if (uploadedNewFits && newFits)
               selected = data.filter(prod => prod.updatedAt >= weekBefore.toISOString())
            else selected = data

            let fineSelected = selected
            if (newFits && !uploadedNewFits)
               fineSelected = selected.filter(prod => prod.updatedAt >= weekBefore.toISOString())

            mounted.current && setSelectedFittingsC(fineSelected)
         
      } catch (err) {
         console.log('some error occured', err.message)
      }
   }, [
      data,
      searchC,
      selectedHoseSizesC,
      selectedDashSizesC,
      setSelectedFittingsC,
      price,
      newFits,
      uploadedNewFits,
      setSortBy,
      sortBy
   ])

   const [anchorNumberChange, setAnchorNumberChange] = useState(null)
   const [numberChange, setNumberChange] = useState(false)
   const [anchorSortChange, setAnchorSortChange] = useState(null)
   const [sortChange, setSortChange] = useState(false)

   const handleNumberChange = event => {
      mounted.current && setNumberChange(true)
      mounted.current && setAnchorNumberChange(event.currentTarget)
   }

   const handleSortChange = event => {
      mounted.current && setSortChange(true)
      mounted.current && setAnchorSortChange(event.currentTarget)
   }

   const handleNumberChangeClose = () => mounted.current && setNumberChange(false)

   const handleSortChangeClose = () => mounted.current && setSortChange(false)


   const handlePrice = () => {
      const test = fittingsC
      const getValue = ({ lPrice }) => +lPrice || 0
      test.sort((a, b) => getValue(a) - getValue(b))
      //setData({ ...data, ...test })
      setData(test)
      setSelectedFittingsC(test)
   }

   const handlePriceHighToLow = () => {
      const test = fittingsC
      const getValue = ({ lPrice }) => +lPrice || 0
      test.sort((a, b) => getValue(b) - getValue(a))
      setData(test)
      setSelectedFittingsC(test)
   }

   const handleNewest = () => {
      const test = fittingsC
      // test.sort(
      //    (objA, objB) => Number(new Date(objA.updatedAt())) - Number(new Date(objB.updatedAt()))
      // )
      test.sort((a, b) => -a.updatedAt.localeCompare(b.updatedAt))
      //console.log(test)
       setData(test)
      setSelectedFittingsC(test)
    
    }

   useEffect(() => {
      mounted.current && setPageNumber(1)
      localStorage.setItem('elements_limit', elementsLimit)
      mounted.current && setNumberChange(false)
   }, [elementsLimit])

   const props = {
      searchC,
      setSearchC,
      setNewFits,
      uploadedNewFits,
      setUploadedNewFits,
      handleSizesC,
      selectedHoseSizesC,
      selectedDashSizesC,
      hoseSizesC,
      dashSizesC,
      setViewC,
      viewC,
      selectedFittingsC,
      setSelectedFittingsC
   }
   const filterbutton = useRef(null)
   const expandmore1 = useRef(null)
   const expandmore2 = useRef(null)
   const expandmore3 = useRef(null)
   const expandless1 = useRef(null)
   const expandless2 = useRef(null)
   const expandless3 = useRef(null)
   const slider = useRef(null)
   const buttonRef = useRef(null)
   const buttonRef1 = useRef(null)
   const [minMax, setMinmax] = useState([])
   const [display1, setDisplay] = useState(false)
   const [display2, setDisplay2] = useState(false)
   const [display3, setDisplay3] = useState(false)
   const [val, setVal] = useState([minMax[0], minMax[1]])
   const [open, setOpen] = React.useState(false)

   const handleClick = () => {
      setOpen(true)
      filterbutton.current.style.display = 'none'
   }

   const handleClose = () => {
      if (open) {
         setOpen(false)
         filterbutton.current.style.display = 'block'
      } else setOpen(false)
   }

   const onButtonclick1 = () => {
      if (!display2) {
         buttonRef1.current.style.display = 'block'
         expandmore1.current.style.display = 'none'
         expandless1.current.style.display = 'inline'
         setDisplay2(true)
      } else if (display2) {
         buttonRef1.current.style.display = 'none'
         expandmore1.current.style.display = 'inline'
         expandless1.current.style.display = 'none'
         setDisplay2(false)
      }
   }

   const onButtonclick2 = () => {
      if (!display1) {
         buttonRef.current.style.display = 'block'
         expandmore2.current.style.display = 'none'
         expandless2.current.style.display = 'inline'
         setDisplay(true)
      } else if (display1) {
         buttonRef.current.style.display = 'none'
         expandmore2.current.style.display = 'inline'
         expandless2.current.style.display = 'none'
         setDisplay(false)
      }
   }

   const onButtonclick3 = () => {
      if (!display3) {
         slider.current.style.display = 'block'
         expandmore3.current.style.display = 'none'
         expandless3.current.style.display = 'inline'
         setDisplay3(true)
      } else if (display3) {
         slider.current.style.display = 'none'
         expandmore3.current.style.display = 'inline'
         expandless3.current.style.display = 'none'
         setDisplay3(false)
      }
   }

   const price1 = [
      {
         value: 0,
         label: 0
      },
      {
         value: parseInt(minMax[1] * 0.2),
         label: parseInt(minMax[1] * 0.2)
      },

      {
         value: parseInt(minMax[1] * 0.4),
         label: parseInt(minMax[1] * 0.4)
      },
      {
         value: parseInt(minMax[1] * 0.6),
         label: parseInt(minMax[1] * 0.6)
      },
      {
         value: parseInt(minMax[1] * 0.8),
         label: parseInt(minMax[1] * 0.8)
      },
      {
         value: parseInt(minMax[1]),
         label: parseInt(minMax[1])
      },
      {
         value: parseInt(minMax[1] * 1.2),
         label: parseInt(minMax[1] * 1.2)
      }
   ]

   const updateRange = (e, data) => {
      setVal(data)
      setPrice(data)
   }

   useEffect(() => {
      async function getRange() {
         let range = await getPublicAPI('/get-range')
         if (range?.success) {
            const { min, max } = range?.data
            let value = []
            value.push(parseInt(min))
            value.push(parseInt(max))
            setMinmax(value)
         } else {
            let value = [0, 100]
            setMinmax(value)
         }
      }
      getRange()
   }, [])

   const clearFilters = () => {
      setNewFits(false)
      setSelectedDashSizesC([])
      setSelectedHoseSizesC([])
      setPrice([])
      setVal([minMax[0], minMax[1]])
   }

   const content = (
      <Box
         sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
         }}
      >
         <Box sx={{ p: 2 }}>
            {uploadedNewFits ||
               (searchC && (hoseSizesC.length > 0 || dashSizesC.length > 0 || newFits)) ? (
               <Box
                  sx={{
                     p: 1,
                     mb: 0,
                     justifyContent: 'space-between',
                     minWidth: '300'
                  }}
               >
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                     <Typography sx={{ fontSize: '20px', fontWeight: '500' }}>FILTERS:</Typography>
                     <Button
                        disabled={
                           !(
                              newFits ||
                              selectedDashSizesC.length > 0 ||
                                 selectedHoseSizesC.length > 0 ||
                                 price.length > 0
                           )
                        }
                        onClick={clearFilters}
                        variant='contained'
                     >
                        Clear
                     </Button>
                  </Box>
                  <Box sx={{ mt: 0 }}>
                     {/* <Box sx={{ mb: 1 }}>
                        <Typography sx={{ fontSize: '16px', fontWeight: '500', color: '#d22f25' }}>
                           <Checkbox
                              checked={newFits}
                              color='primary'
                              onChange={() => setNewFits(!newFits)}
                           />
                           {localStorage.user_type !== 'customer'
                              ? 'RECENTLY UPLOADED'
                              : 'NEW PRODUCTS'}
                        </Typography>
                     </Box> */}
                     {hoseSizesC.length > 0 && (
                        <Box>
                           <Divider />
                           <Button
                              fullWidth
                              sx={{ padding: 2, justifyContent: 'left' }}
                              onClick={onButtonclick1}
                           >
                              <Grid container spacing={3}>
                                 <Grid item xs={3}>
                                    <Typography
                                       sx={{ fontSize: '16px', fontWeight: '500', float: 'left' }}
                                    >
                                       Pressure{' '}
                                    </Typography>
                                 </Grid>
                                 <Grid item xs={9}>
                                    <ExpandMoreIcon
                                       ref={expandmore1}
                                       style={{
                                          float: 'right',
                                          color: '#8c8c8c',
                                          display: 'inline'
                                       }}
                                    />
                                    <ExpandLessIcon
                                       ref={expandless1}
                                       style={{
                                          float: 'right',
                                          color: '#8c8c8c',
                                          display: 'none'
                                       }}
                                    />
                                 </Grid>
                              </Grid>
                           </Button>
                           <Typography ref={buttonRef1} style={{ display: 'none' }}>
                              {hoseSizesC.map(size => (
                                 <Typography key={size}>
                                    <Checkbox
                                       checked={selectedHoseSizesC.includes(size)}
                                       color='primary'
                                       onChange={() => handleSizesC('hose', size)}
                                    />
                                    {`-${size.slice(-2)}`}
                                 </Typography>
                              ))}
                           </Typography>
                           <Divider />
                        </Box>
                     )}

                     {dashSizesC.length > 0 && (
                        <>
                           <Button
                              fullWidth
                              sx={{ padding: 2, justifyContent: 'left' }}
                              onClick={onButtonclick2}
                           >
                              <Grid container spacing={3}>
                                 <Grid item xs={3}>
                                    <Typography
                                       sx={{ fontSize: '16px', fontWeight: '500', float: 'left' }}
                                    >
                                       Size{' '}
                                    </Typography>
                                 </Grid>
                                 <Grid item xs={9}>
                                    <ExpandMoreIcon
                                       ref={expandmore2}
                                       style={{
                                          float: 'right',
                                          color: '#8c8c8c'
                                       }}
                                    />
                                    <ExpandLessIcon
                                       ref={expandless2}
                                       style={{
                                          float: 'right',
                                          color: '#8c8c8c',
                                          display: 'none'
                                       }}
                                    />
                                 </Grid>
                              </Grid>
                           </Button>
                           <Box ref={buttonRef} style={{ display: 'none' }}>
                              {dashSizesC.map(size => (
                                 <Typography key={size}>
                                    <Checkbox
                                       checked={selectedDashSizesC.includes(size)}
                                       color='primary'
                                       onChange={() => handleSizesC('dash', size)}
                                    />
                                    {`-${size.slice(-2)}`}
                                 </Typography>
                              ))}
                           </Box>
                           <Divider />
                        </>
                     )}
                     <Button
                        fullWidth
                        sx={{ padding: 2, justifyContent: 'left' }}
                        onClick={onButtonclick3}
                     >
                        <Grid container spacing={3}>
                           <Grid item xs={3}>
                              <Typography
                                 id='discrete-slider-custom'
                                 sx={{
                                    fontSize: '16px',
                                    fontWeight: '500',
                                    paddingBottom: 0,
                                    float: 'left'
                                 }}
                                 gutterBottom
                              >
                                 Price($){' '}
                              </Typography>
                           </Grid>
                           <Grid item xs={9}>
                              <ExpandMoreIcon
                                 ref={expandmore3}
                                 style={{
                                    float: 'right',
                                    color: '#8c8c8c'
                                 }}
                              />
                              <ExpandLessIcon
                                 ref={expandless3}
                                 style={{
                                    float: 'right',
                                    color: '#8c8c8c',
                                    display: 'none'
                                 }}
                              />
                           </Grid>
                        </Grid>
                     </Button>
                     <Typography
                        ref={slider}
                        style={{
                           display: 'none',
                           paddingLeft: 20,
                           paddingTop: 20,
                           paddingRight: 15
                        }}
                     >
                        <Slider
                           aria-labelledby='discrete-slider-custom'
                           color='primary'
                           valueLabelDisplay='on'
                           defaultValue={parseInt(minMax[1] * 1.2)}
                           value={val}
                           onChange={updateRange}
                           marks={price1}
                           min={parseInt(minMax[0])}
                           max={parseInt(minMax[1] * 1.2)}
                        />
                     </Typography>
                  </Box>
               </Box>
            ) : (
               <></>
            )}
         </Box>

         {/* <Box
            sx={{
               backgroundColor: 'background.default',
               m: 2,
               p: 2
            }}
         >
            <Typography align='center' gutterBottom variant='h4'>
               Need more?
            </Typography>
            <Typography align='center' variant='body2'>
               Upgrade to PRO version and access 20 more screens
            </Typography>
            <Box
               sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  pt: 2
               }}
            >
               <Button
                  color='primary'
                  component='a'
                  href='https://react-material-kit.devias.io'
                  variant='contained'
               >
                  See PRO version
               </Button>
            </Box>
         </Box> */}
      </Box>
   )

   return (
      <>
         <Helmet>
            <title>{loading ? 'Loading...' : 'Fittings | The HosePod'}</title>
         </Helmet>
         <Box
            sx={{
               backgroundColor: 'background.default',
               minHeight: '100%',
               py: 3
            }}
         >
            <Container maxWidth={false}>
               {loading ? (
                  <Loader />
               ) : (
                  <>
                     {(selectedFittingsC.length > 0) && <ProductListToolbar prop={props} />}
                     {searchC ||
                     selectedHoseSizesC?.length > 0 ||
                     selectedDashSizesC?.length > 0 ||
                     uploadedNewFits ? (
                        selectedFittingsC.length > pageNumber * elementsLimit ? (
                           <>
                              <Box
                                 sx={{
                                    display: 'flex',
                                    flexDirection: windowWidth < 450 ? 'column' : 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    pt: 3
                                 }}
                              >
                                 <Box></Box>
                                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography variant='h5'>Sort: </Typography>
                                    <Button
                                       sx={{ width: 200, ml: 2 }}
                                       variant='outlined'
                                       endIcon={<ArrowDropDownIcon />}
                                       style={{}}
                                       aria-owns={sortChange ? 'sort-change' : null}
                                       aria-haspopup='true'
                                       onClick={handleSortChange}
                                       // onMouseOver={handleNumberChange}
                                    >
                                       {sortBy}
                                    </Button>
                                    <Menu
                                       sx={{ top: -20 }}
                                       id='sort-change'
                                       className='nav-menu'
                                       anchorEl={anchorSortChange}
                                       open={sortChange}
                                       onClose={handleSortChangeClose}
                                       PaperProps={{
                                          style: {
                                             mt: 0,
                                             width: 200
                                          }
                                       }}
                                    >
                                       <MenuItem
                                          onClick={() => {
                                             setSortBy('Newest')
                                             //handleNewest()
                                             handleSortChangeClose()
                                          }}
                                       >
                                          Newest
                                       </MenuItem>
                                       <MenuItem
                                          onClick={() => {
                                             setSortBy('Price low to high')
                                             //handlePrice()
                                             handleSortChangeClose()
                                          }}
                                       >
                                          Price low to high
                                       </MenuItem>
                                       <MenuItem
                                          onClick={() => {
                                             setSortBy('Price high to low')
                                             //handlePriceHighToLow()
                                             handleSortChangeClose()
                                          }}
                                       >
                                          Price high to low
                                       </MenuItem>
                                    </Menu>
                                 </Box>
                              </Box>
                              <Box
                                 sx={{
                                    display: 'flex',
                                    flexDirection: windowWidth < 450 ? 'column' : 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    pt: 3
                                 }}
                              >
                                 <Pagination
                                    color='primary'
                                    count={Math.ceil(selectedFittingsC.length / elementsLimit)}
                                    onChange={(e, n) => setPageNumber(n)}
                                    size='small'
                                    page={pageNumber}
                                 />
                                 <Box sx={{}}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                       <Typography variant='h5' color='#d22f25'>
                                          {elementsLimit}
                                       </Typography>
                                       <Button
                                          endIcon={<ArrowDropDownIcon />}
                                          aria-owns={numberChange ? 'number-change' : null}
                                          aria-haspopup='true'
                                          onClick={handleNumberChange}
                                       >
                                          Items per page:
                                       </Button>
                                    </Box>
                                    <Menu
                                       id='number-change'
                                       className='nav-menu'
                                       anchorEl={anchorNumberChange}
                                       open={numberChange}
                                       onClose={handleNumberChangeClose}
                                       PaperProps={{
                                          style: {
                                             width: 200
                                          }
                                       }}
                                    >
                                       <MenuItem onClick={() => setElementsLimit(12)}>12</MenuItem>
                                       <MenuItem onClick={() => setElementsLimit(24)}>24</MenuItem>
                                       <MenuItem onClick={() => setElementsLimit(36)}>36</MenuItem>
                                    </Menu>
                                 </Box>
                              </Box>
                           </>
                        ) : (
                           <></>
                        )
                     ) : (
                        <>
                           <Box
                              sx={{
                                 display: 'flex',
                                 flexDirection: windowWidth < 450 ? 'column' : 'row',
                                 justifyContent: 'space-between',
                                 alignItems: 'center',
                                 pt: 3
                              }}
                           >
                              <Box></Box>
                              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                 <Typography variant='h5'>Sort: </Typography>
                                 <Button
                                    sx={{ width: 200, ml: 2 }}
                                    variant='outlined'
                                    endIcon={<ArrowDropDownIcon />}
                                    style={{}}
                                    aria-owns={sortChange ? 'sort-change' : null}
                                    aria-haspopup='true'
                                    onClick={handleSortChange}
                                    // onMouseOver={handleNumberChange}
                                 >
                                    {sortBy}
                                 </Button>
                                 <Menu
                                    sx={{ top: -20 }}
                                    id='sort-change'
                                    className='nav-menu'
                                    anchorEl={anchorSortChange}
                                    open={sortChange}
                                    onClose={handleSortChangeClose}
                                    PaperProps={{
                                       style: {
                                          mt: 0,
                                          width: 200
                                       }
                                    }}
                                 >
                                    <MenuItem
                                       onClick={() => {
                                          setSortBy('Newest')
                                          handleNewest()
                                          handleSortChangeClose()
                                       }}
                                    >
                                       Newest
                                    </MenuItem>
                                    <MenuItem
                                       onClick={() => {
                                          setSortBy('Price low to high')
                                          handlePrice()
                                          handleSortChangeClose()
                                       }}
                                    >
                                       Price low to high
                                    </MenuItem>
                                    <MenuItem
                                       onClick={() => {
                                          setSortBy('Price high to low')
                                          handlePriceHighToLow()
                                          handleSortChangeClose()
                                       }}
                                    >
                                       Price high to low
                                    </MenuItem>
                                 </Menu>
                              </Box>
                           </Box>
                           <Box
                              sx={{
                                 display: 'flex',
                                 flexDirection: windowWidth < 450 ? 'column' : 'row',
                                 justifyContent: 'space-between',
                                 alignItems: 'center',
                                 pt: 3
                              }}
                           >
                              <Pagination
                                 color='primary'
                                 count={Math.ceil(fittingsC.length / elementsLimit)}
                                 onChange={(e, n) => setPageNumber(n)}
                                 page={pageNumber}
                                 size='small'
                              />
                              <Box sx={{}}>
                                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography variant='h5' color='#d22f25'>
                                       {elementsLimit}
                                    </Typography>
                                    <Button
                                       endIcon={<ArrowDropDownIcon />}
                                       style={{}}
                                       aria-owns={numberChange ? 'number-change' : null}
                                       aria-haspopup='true'
                                       onClick={handleNumberChange}
                                       // onMouseOver={handleNumberChange}
                                    >
                                       Items per page:
                                    </Button>
                                 </Box>
                                 <Menu
                                    id='number-change'
                                    className='nav-menu'
                                    anchorEl={anchorNumberChange}
                                    open={numberChange}
                                    onClose={handleNumberChangeClose}
                                    PaperProps={{
                                       style: {
                                          width: 200
                                       }
                                    }}
                                 >
                                    <MenuItem onClick={() => setElementsLimit(12)}>12</MenuItem>
                                    <MenuItem onClick={() => setElementsLimit(24)}>24</MenuItem>
                                    <MenuItem onClick={() => setElementsLimit(36)}>36</MenuItem>
                                 </Menu>
                              </Box>
                           </Box>
                        </>
                     )}

                     <Box sx={{ pt: 3 }}>
                        <Grid container spacing={3}>
                           {searchC && selectedFittingsC?.length > 0 && (
                              <Grid container spacing={3} sx={{ justifyContent: 'center' }}>
                                 <Typography sx={{ pt: 5, fontSize: '18px', fontWeight: '500' }}>
                                    Showing {selectedFittingsC?.length} results for "Fittings"{' '}
                                 </Typography>
                              </Grid>
                           )}
                           <Grid container spacing={3} sx={{ justifyContent: 'center' }}>
                              {searchC ||
                              selectedHoseSizesC?.length > 0 ||
                              selectedDashSizesC?.length > 0 ? (
                                 selectedFittingsC?.length === 0 ? (
                                    <Typography sx={{ p: 7, fontSize: '24px', fontWeight: '500' }}>
                                       No fittings for your search
                                    </Typography>
                                 ) : (
                                    <></>
                                 )
                              ) : fittingsC?.length === 0 ? (
                                 <Typography sx={{ p: 7, fontSize: '24px', fontWeight: '500' }}>
                                    No fittings found
                                 </Typography>
                              ) : (
                                 <></>
                              )}
                           </Grid>
                           {viewC || windowWidth < 450 ? (
                              <>
                                 {searchC && selectedFittingsC?.length > 0 && windowWidth <= 450 && (
                                    <Box>
                                       <Box sx={{ marginLeft: windowWidth * 0.095, pt: 2 }}>
                                          <Button
                                             ref={filterbutton}
                                             variant='outlined'
                                             sx={{
                                                color: '#249169',
                                                borderColor: '#f5f5fa',
                                                backgroundColor: '#f0efed',
                                                display: 'block'
                                             }}
                                             onClick={handleClick}
                                          >
                                             <Typography>Filter</Typography>
                                          </Button>
                                       </Box>
                                       <>
                                          <Box>
                                             <Drawer
                                                anchor='bottom'
                                                onClose={handleClose}
                                                open={open}
                                                variant='temporary'
                                                PaperProps={{
                                                   sx: {
                                                      width: windowWidth,
                                                      height: windowHeight * 0.4,
                                                      backgroundColor: '#ecf0f1',
                                                      borderTopLeftRadius: 15,
                                                      borderTopRightRadius: 15
                                                   }
                                                }}
                                             >
                                                {content}
                                             </Drawer>
                                          </Box>
                                       </>
                                    </Box>
                                 )}
                                 {searchC ||
                                 selectedHoseSizesC?.length > 0 ||
                                 selectedDashSizesC?.length > 0 ||
                                 uploadedNewFits
                                    ? selectedFittingsC.length > pageNumber * elementsLimit
                                       ? selectedFittingsC
                                            ?.slice(
                                               (pageNumber - 1) * elementsLimit,
                                               pageNumber * elementsLimit
                                            )
                                            .map(product => (
                                               <>
                                                  <Grid
                                                     item
                                                     key={product._id}
                                                     xl={2}
                                                     lg={3}
                                                     sm={4}
                                                     xs={12}
                                                  >
                                                     <ProductCard product={product} />
                                                  </Grid>
                                               </>
                                            ))
                                       : selectedFittingsC.map(product => (
                                            <Grid
                                               item
                                               key={product._id}
                                               xl={2}
                                               lg={3}
                                               sm={4}
                                               xs={12}
                                            >
                                               <ProductCard product={product} />
                                            </Grid>
                                         ))
                                    : fittingsC
                                         ?.slice(
                                            (pageNumber - 1) * elementsLimit,
                                            pageNumber * elementsLimit
                                         )
                                         .map(product => (
                                            <Grid
                                               item
                                               key={product._id}
                                               xl={2}
                                               lg={3}
                                               sm={4}
                                               xs={12}
                                            >
                                               <ProductCard product={product} />
                                            </Grid>
                                         ))}
                              </>
                           ) : (
                              <>
                                 {searchC ||
                                 selectedHoseSizesC?.length > 0 ||
                                 selectedDashSizesC?.length > 0 ||
                                 uploadedNewFits
                                    ? selectedFittingsC.length > pageNumber * elementsLimit
                                       ? selectedFittingsC
                                            ?.slice(
                                               (pageNumber - 1) * elementsLimit,
                                               pageNumber * elementsLimit
                                            )
                                            .map(product => (
                                               <Grid item key={product._id} xs={12}>
                                                  <ProductListCard product={product} />
                                               </Grid>
                                            ))
                                       : selectedFittingsC.map(product => (
                                            <Grid item key={product._id} xs={12}>
                                               <ProductListCard product={product} />
                                            </Grid>
                                         ))
                                    : fittingsC
                                         ?.slice(
                                            (pageNumber - 1) * elementsLimit,
                                            pageNumber * elementsLimit
                                         )
                                         .map(product => (
                                            <Grid item key={product._id} xs={12}>
                                               <ProductListCard product={product} />
                                            </Grid>
                                         ))}
                              </>
                           )}
                        </Grid>
                     </Box>
                     {searchC ||
                     selectedHoseSizesC?.length > 0 ||
                     selectedDashSizesC?.length > 0 ||
                     uploadedNewFits ? (
                        selectedFittingsC.length > pageNumber * elementsLimit ? (
                           <Box
                              sx={{
                                 display: 'flex',
                                 flexDirection: windowWidth < 450 ? 'column' : 'row',
                                 justifyContent: 'space-between',
                                 alignItems: 'center',
                                 pt: 3
                              }}
                           >
                              <Pagination
                                 color='primary'
                                 count={Math.ceil(selectedFittingsC.length / elementsLimit)}
                                 onChange={(e, n) => setPageNumber(n)}
                                 page={pageNumber}
                                 size='small'
                              />
                              <Box sx={{}}>
                                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography variant='h5' color='#d22f25'>
                                       {elementsLimit}
                                    </Typography>
                                    <Button
                                       endIcon={<ArrowDropDownIcon />}
                                       style={{}}
                                       aria-owns={numberChange ? 'number-change' : null}
                                       aria-haspopup='true'
                                       onClick={handleNumberChange}
                                       // onMouseOver={handleNumberChange}
                                    >
                                       Items per page:
                                    </Button>
                                 </Box>
                                 <Menu
                                    id='number-change'
                                    className='nav-menu'
                                    anchorEl={anchorNumberChange}
                                    open={numberChange}
                                    onClose={handleNumberChangeClose}
                                    PaperProps={{
                                       style: {
                                          width: 200
                                       }
                                    }}
                                 >
                                    <MenuItem onClick={() => setElementsLimit(12)}>12</MenuItem>
                                    <MenuItem onClick={() => setElementsLimit(24)}>24</MenuItem>
                                    <MenuItem onClick={() => setElementsLimit(36)}>36</MenuItem>
                                 </Menu>
                              </Box>
                           </Box>
                        ) : (
                           <></>
                        )
                     ) : (
                        <Box
                           sx={{
                              display: 'flex',
                              flexDirection: windowWidth < 450 ? 'column' : 'row',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              pt: 3
                           }}
                        >
                           <Pagination
                              color='primary'
                              count={Math.ceil(fittingsC.length / elementsLimit)}
                              onChange={(e, n) => setPageNumber(n)}
                              page={pageNumber}
                              size='small'
                           />
                           <Box sx={{}}>
                              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                 <Typography variant='h5' color='#d22f25'>
                                    {elementsLimit}
                                 </Typography>
                                 <Button
                                    endIcon={<ArrowDropDownIcon />}
                                    style={{}}
                                    aria-owns={numberChange ? 'number-change' : null}
                                    aria-haspopup='true'
                                    onClick={handleNumberChange}
                                    // onMouseOver={handleNumberChange}
                                 >
                                    Items per page:
                                 </Button>
                              </Box>
                              <Menu
                                 id='number-change'
                                 className='nav-menu'
                                 anchorEl={anchorNumberChange}
                                 open={numberChange}
                                 onClose={handleNumberChangeClose}
                                 PaperProps={{
                                    style: {
                                       width: 200
                                    }
                                 }}
                              >
                                 <MenuItem onClick={() => setElementsLimit(12)}>12</MenuItem>
                                 <MenuItem onClick={() => setElementsLimit(24)}>24</MenuItem>
                                 <MenuItem onClick={() => setElementsLimit(36)}>36</MenuItem>
                              </Menu>
                           </Box>
                        </Box>
                     )}
                  </>
               )}
            </Container>
         </Box>
      </>
   )
}

export default ProductList